const programs = [
  // btech-marine
  {
    id: "btech-marine",
    title: "B.Tech in Marine Engineering",
    image: "/assets/images/programs-offered/B.Tech Marine-2.webp",
    eligibility:
      "Eligibility Entrance IMU CET/State level Engineering Exam/JEE (with more than 40 Percentile) qualified candidates are eligible, PCM 60% in 12th Std. 50% in English either in 10th or 12th",
    duration: "4 Years (Residential Program)",
    age: "25 Years",
    intake: "120",
    descriptionSections: [
      {
        text: "MANET Pune is one of the best colleges for B. Tech in Marine Engineering, offering a 4-year degree course for cadets to enhance their knowledge and practical skills. The B. Tech Marine Engineering course details include training on the ship-in-campus, learning from expert faculty members, and interacting with industry specialists to help cadets maximize their potential before they enter the shipping industry.",
      },
      {
        heading: "Definition of Marine Engineering & role of Marine Engineers:",
        text: "Marine Engineering deals with the operation and maintenance of ship machinery and engines. Marine Engineers perform the enviable task of operating & maintaining the machinery in a safe & efficient way which needs knowledge & skills of a very high order.",
      },
      {
        heading: "Highlights of MANET B. Tech Marine Engineering:",
        text: "After completion of B. Tech Marine Engineering, cadets work as Junior Engineers on Merchant Ships of Indian or Foreign companies. On completion of the stipulated periods on the ship and passing the Competency Examination conducted by the Directorate General of Shipping, Ministry of Shipping, Government of India, Junior Engineers eventually become eligible to be posted as Chief Engineers of a Ship.",
      },
    ],
    careerCards: [
      {
        title: "Trainee Engineer",
        desc: "4 Years Degree (Marine Engineering) + Four Basic STCW modular courses.",
      },
      {
        title: "4th / 3rd Engineer",
        desc: "6 months sea service as a Trainee Engineer + 3 months preparatory courses (opt.) + passing in Class IV part B exam ",
      },
      {
        title: "2nd Engineer",
        desc: "12 months sea service as a Class IV Engineer + 4 months preparatory courses + passing in Class II exam",
      },
      {
        title: "Chief Engineer",
        desc: "18 months sea service as a Second Engineer with class II Certificate + 2 months course + passing in Class I exam",
      },
    ],
    apply: "/admissions/admission-2026",
  },

  // bsc-nautical
  {
    id: "bsc-nautical",
    title: "B. Sc. Nautical Science ",
    image: "/assets/images/programs-offered/B.Sc-1.webp",
    eligibility:
      "IMU CET/State level Engineering Entrance Exam/JEE (with more than 40 Percentile) qualified candidates are eligible, PCM 60% in 12th Std, 50% in English either in 10th or 12th ",
    duration: "3 Years (Residential Program) ",
    age: "25 Years",
    intake: "120",
    descriptionSections: [
      {
        text:
          "MANET is one of the best institutes for B.Sc. in Nautical Science in Pune, offering pre-sea training for cadets who want to become the captain of a merchant ship in the future. During the B.Sc. Nautical Science training, cadets learn all about character-building and developing the skills of a seafarer. Young cadets also imbibe high moral and ethical values like honesty, discipline, punctuality, hard work, modesty, and perseverance, which play a major role during life at sea. ",
      },
      {
        text:
          "The 3-year B.Sc. Nautical Science course at MANET offers both theoretical and practical knowledge required for seamanship, navigation, watchkeeping, cargo handling, naval architecture, and ship maintenance and operation. Along with these, cadets are also taught managerial skills with hands-on training. ",
      },
      {
        heading:
          "Definition & Role of Navigation Officers after Completing their B.Sc. in Nautical Science:  ",
        text: "Navigation Officers deal with the navigation and administration of the vessel. Navigating Officers are responsible for the safe navigation and responsible for the loading and discharging of cargo, radio communication of ships, and safety of the crew & passengers. ",
      },
      {
        heading: "Highlights of MANET B.Sc. Nautical Science: ",
        text: "The cadets after successful completion of their B.Sc. Nautical Science Degree Course are eligible to be directly placed on-board various Indian or Foreign vessels. After acquiring requisite sea time and obtaining the Certificate of Competency, they can rise to the level of Master (Captain). ",
      },
    ],
    careerCards: [
      {
        title:
          "Navigation Officer Trainee (Deck Cadet)",
        desc: "3 Years Degree (Nautical Science) + Four Basic STCW modular courses ",
      },
      {
        title: "3rd / 2nd Officer",
        desc: "12 months sea service as a Deck Cadet + 2nd Mate (Going abroad) Certification ",
      },
      {
        title: " Chief Officer",
        desc: "18 months sea service as a Second Officer + 6 months First Mate (going abroad) course + Modular Courses + Passing in Written & Oral Exams ",
      },
      {
        title: "Master (Captain)",
        desc: "18 months sea service as a Chief Officer + 1-month ASM Course + Master Exam ",
      },
    ],
    apply: "/admissions/admission-2026",
  },

  // diploma-nautical
  {
    id: "diploma-nautical",
    title: "Diploma In Nautical Science ",
    image: "/assets/images/programs-offered/DNS-2.webp",
    eligibility:
      "IMU-CET qualified candidate are eligible, PCM 60% in 12th Std, 50% in English either in 10th or 12th ",
    duration: "1 Year (Residential Program) ",
    age: "25 Years",
    intake: "40",
    descriptionSections: [
      {
        text: "MANET is one of the best institutes for Diploma in Nautical Science in Pune, offering pre-sea training for cadets who want to become the captain of a merchant ship in the future. During the Diploma Nautical Science training, cadets learn all about character-building and developing the skills of a seafarer. Young cadets also imbibe high moral and ethical values like honesty, discipline, punctuality, hard work, modesty, and perseverance, which play a major role during life at sea. ",
      },
      {
        text: "The 1-year Diploma Nautical Science course at MANET offers both theoretical and practical knowledge required for seamanship, navigation, watchkeeping, cargo handling, naval architecture, and ship maintenance and operation. Along with these, cadets are also taught managerial skills with hands-on training. ",
      },
      {
        heading:
          "Definition & Role of Navigation Officers after Completing their Diploma in Nautical Science: ",
        text: "Navigation Officers deal with the navigation and administration of the vessel. Navigating Officers are responsible for the safe navigation and the loading and discharging of cargo, radio communication of ships, and the safety of the crew & passengers. ",
      },
      {
        heading: "Highlights of MANET Diploma Nautical Science: ",
        text: "The pre-sea course consists of two semesters, each semester being 6 months in duration. After completion of the course, cadets are required to undergo the Structured Shipboard Training Program (SSTP) which consists of 18 months of on-board training which consists of three semesters i.e. III, IV, and V, approximately 6 months in duration each. During the on-board training, a cadet is entitled to a stipend, free boarding, and lodging",
      },
      {
        text: "After completion of on-board training, a cadet has to obtain an SSTP completion certificate from the institute and has to attempt/ appear for Semester III, IV & V Exams. Subsequently, the cadet has to attend 4 months of post-sea, shore-based training (Semester VI) which is the preparatory course for the 'Second Mates' examination conducted by the Director General of Shipping (DGS), at approved institutes. The cadet needs to complete mandatory STCW courses (ROC/ARPA, GMDSS, PSCRB, AFF, MFA, and ECDIS) for the 'Second Mates' (FG) license which takes approximately 2 months. ",
      },
      {
        text: "On successful completion of the Second Mates examination and STCW courses, a cadet is awarded with Second Mates (F.G) Certificate of Competency by D.G. Shipping, Govt. of India, and qualifies to join any sea- going vessel as a third officer. ",
      },
      {
        text: "After completing all six semesters, a cadet is awarded a degree of B.Sc. (Applied Nautical Science). ",
      },
      {
        heading: "Please Note:",
        text: [
          "Candidates seeking admissions to Marine Programs are strongly recommended to have Passports. Please note that the name on the Passport should be the same as given in the 10th Std. Certificate.",
          "Admission to this course is granted after passing the IMU CET exam successfully and fulfilling the below- mentioned eligibility criteria.",
        ],
      },
      {
        heading: "Sponsorship",
        text: "MANET accepts only company-sponsored candidates for admission. Though any registered shipping company can sponsor candidates for the DNS program, the following companies normally sponsor candidates:",
        companies: {
          col1: [
            "Fleet Management",
            "MSC",
            "Nortrans",
            "Scorpio Marine Management",
            "TORM",
            "V-Ships",
            "Wilhelmsen Ship Management",
          ],
          col2: [
            "DeeVee Shipping",
            "DRS Marine",
            "Eklavya Ship Management",
            "Fleet Management",
            "Lilly Maritime",
            "Sun Tech Shipping",
            "Tolani Shipping",
          ],
        },
      },
    ],
    careerCards: [
      {
        title:
          "Trainee Navigating Officer (Deck Cadet)",
        desc: "1 Year Diploma in Nautical Science + 5 Basic STCW Modular courses ",
      },
      {
        title: "Chief Officer ",
        desc: "18 Months sea service as a Second Officer + 6 Months First Mate (Foreign going) course + Modular Courses + passing in written & oral exam ",
      },
      {
        title:
          "3rd Officer/ 2nd Officer",
        desc: "18 Months sea service as a Deck Cadet + 2 Mate Course (4 Month) + 2 Mate (FG) Certification ",
      },
      {
        title: "Master (Captain)",
        desc: "18 Months sea service as a second Officer (or 12 Month sea service as a chief officer + 1 Month ASM course + Modular Master exam ",
      },
    ],
    apply: "/admissions/admission-2026",
  },

  // electro-technical
  {
    id: "electro-technical",
    title: "Electro Technical Officer ",
    image: "/assets/images/programs-offered/ETO-2.webp",
    eligibility: "see in the description ",
    duration: "4 months ( Yearly 2 Batches – Jan. & Aug.) ",
    age: "35 Years",
    intake: "80",
    descriptionSections: [
      {
        heading: "Our ETO Course: Your Pathway to a Dynamic Career at Sea ",
        text: " Designed to meet the highest industry standards, this 17-week program provides the comprehensive training you need to excel as an Electro-Technical Officer (ETO).",
      },
      {
        heading: "Real-World Training for Real-World Success ",
        text: "Gain hands-on expertise through a blend of classroom learning and practical application. Our curriculum, aligned with STCW standards, covers:",
        text: [
          "Core Electrical Systems: Master the fundamentals of power generation, distribution, and utilization on ships.",
          "Advanced Automation: Develop proficiency in operating and troubleshooting complex automation systems.",
          "Practical Maintenance: Learn to efficiently maintain and repair electrical equipment.",
          "Safety First: Gain a deep understanding of maritime safety protocols and emergency procedures.",
          "Effective Communication: Enhance your communication and interpersonal skills for success in a global industry.",
        ],
      },
      {
        heading: "Eligibility Criteria ",
        text: "To qualify for the ETO course, you must meet the following criteria:",
        text: [
          "English Proficiency: A minimum of 50% marks in English at either the 10th or 12th standard, degree level is required.",
          "Degree in Engineering:",
          [
            "A four-year degree (including lateral entry) with 50% marks in Electrical Engineering, Electronics Engineering, Electrical & Electronics Engineering, Electronics & Telecommunication/Communication Engineering, or Electronics and Instrumentation Engineering is required.",
            "If English marks are less than 50% at 10th or 12th, but the diploma/degree was taught in English and other criteria are met, eligibility may be considered.",
          ],
          " Medical Fitness: ",
          "Medical Fitness certificate from a D.G. Approved doctor is required.",
        ],
      },
    ],
    careerCards: [
      {
        title: "Trainee ETO",
        desc: " A 4-month training program at an institute Including 2 weeks STCW courses",
      },
      {
        title: "Assistant ETO",
        desc: "An 8-month training program on a ship as a Trainee Electro Technical Officer + COC exam ",
      },
      {
        title:
          "Electro Technical Officer",
        desc: "Junior ETO rising to Senior ETO with rank experience + High voltage course as required ",
      },
    ],
    apply: "/admissions/admission-2026",
  },
];

export default programs;
